import styled from 'styled-components';

import colors from '../../styles/colors';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
`;

export const Badge = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  min-width: 26px;
  height: 26px;
  padding: 0 7px;
  border-radius: 13px;
  border: 1px solid ${({ $mine }) => ($mine ? colors.base.secondary : colors.shades.gamma1)};
  background: ${({ $mine }) => ($mine ? colors.addAlpha(colors.base.secondary, 0.12) : colors.base.gamma)};
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
`;

export const AvidaEmoji = styled.img`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  object-fit: cover;
`;

export const Count = styled.span`
  font-size: 11px;
  color: ${colors.shades.gamma10};
`;
